import { ChatBox } from "../../../shared/ChatBox";
import type { ChatConfig } from "./types";
import { Flex, Text } from "@simplybusiness/mobius";

interface QuestionChatBoxProps {
  questionName: string;
  chatConfig: ChatConfig;
}

export const QuestionChatBox = ({
  questionName,
  chatConfig: { text, hintText, chatLabel },
}: QuestionChatBoxProps) => {
  return (
    <ChatBox className="mobius-question__chatbox" position="left">
      <Text variant="body">{text}</Text>
      {!!hintText && (
        <Text variant="body">
          <strong>Hint: {hintText}</strong>
        </Text>
      )}
      <Flex className="mobius-question__chatbox-link-container">
        <Text variant="body">Still unsure?</Text>
        <ChatBox.ChatLink label={chatLabel} questionName={questionName} />
      </Flex>
    </ChatBox>
  );
};
